export const menuCategories = [
  {
    title: "Asset Classes",
    items: [
      { title: "Crypto", id: 205463 },
      { title: "Energy", id: 195277 },
      { title: "Equities", id: 195276 },
      { title: "Fixed Income", id: 195275 },
      { title: "Forex", id: 195274 },
      { title: "Metals", id: 195278 },
    ],
  },
  {
    title: "Central Banks",
    items: [
      { title: "Bank Research", id: 205460 },
      { title: "BoC", id: 194880 },
      { title: "BoE", id: 194879 },
      { title: "BoJ", id: 194881 },
      { title: "ECB", id: 194882 },
      { title: "Fed", id: 195292 },
      { title: "Other Central Banks", id: 205443 },
      { title: "PBoC", id: 194883 },
      { title: "RBA", id: 194884 },
      { title: "RBNZ", id: 194886 },
      { title: "SNB", id: 194888 },
    ],
  },
  {
    title: "Economic Releases",
    items: [
      { title: "Canadian Data", id: 205444 },
      { title: "EU Data", id: 205441 },
      { title: "Other Data", id: 205445 },
      { title: "Swiss Data", id: 205440 },
      { title: "UK Data", id: 205452 },
      { title: "US Data", id: 205439 },
    ],
  },
  {
    title: "Equities",
    items: [
      { title: "Asian Equities", id: 205454 },
      { title: "CAC", id: 205437 },
      { title: "DAX", id: 198080 },
      { title: "EUROSTOXX", id: 205451 },
      { title: "European Equities", id: 205456 },
      { title: "FTSE 100", id: 205455 },
      { title: "Global Equities", id: 205457 },
      { title: "SMI", id: 205438 },
      { title: "UK Equities", id: 205458 },
      { title: "US Equities", id: 205453 },
      { title: "US Equity Plus", id: 205465 },
    ],
  },
  {
    title: "News Commentary",
    items: [
      { title: "Ags & Softs", id: 205462 },
      { title: "Asian News", id: 205459 },
      { title: "Brexit", id: 195832 },
      { title: "Economic Commentary", id: 195267 },
      { title: "Emerging Markets", id: 205464 },
      { title: "Energy & Power", id: 205446 },
      { title: "FX Flows", id: 205447 },
      { title: "Geopolitical", id: 195270 },
      { title: "Global News", id: 205449 },
      { title: "Market Analysis", id: 205442 },
      { title: "Rating Agency comments", id: 205448 },
      { title: "Trade", id: 205436 },
      { title: "US Election", id: 205461 },
    ],
  },
  {
    title: "Newsquawk Update",
    items: [
      { title: "Newsquawk Economic Releases", id: 205466 },
      { title: "Newsquawk Update", id: 205450 },
    ],
  },
  {
    title: "Sections",
    items: [
      { title: "Important", id: 195272 },
      { title: "Rumour", id: 195271 },
    ],
  },
];

export const assetClasses = [
  { title: "Crypto", id: 205463 },
  { title: "Energy", id: 195277 },
  { title: "Equities", id: 195276 },
  { title: "Fixed Income", id: 195275 },
  { title: "Forex", id: 195274 },
  { title: "Important", id: 195272 },
  { title: "Metals", id: 195278 },
];
